







































































import { Component, Vue } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import { ThemeConfig } from "../../plugins/config";

const namespace: string = "authModule";

@Component({ name: "recovery-password" })
export default class RecoveryPassword extends Vue {
  @Action("recoveryPassword", { namespace })
  private recoveryPassword!: (login: string) => Promise<void>;

  @Getter("theme")
  public theme!: ThemeConfig;

  private isLoading = false;
  private httpReturnedObj: object = {};
  private login: string = "";

  public async recovery(): Promise<void> {
    if (this.login === "") {
      this.httpReturnedObj = {
        message: "Username cannot be empty",
        status: 400,
      };
    } else {
      try {
        this.$Progress.start();
        this.isLoading = true;
        await this.recoveryPassword(this.login);
        this.httpReturnedObj = {
          message: `Account details successfully sent to ${this.login}`,
          status: 200,
        };
        this.$Progress.finish();
        this.isLoading = false;
      } catch (e) {
        this.httpReturnedObj = e;
        this.$Progress.fail();
      } finally {
        this.isLoading = false;
      }
    }
  }

  get loadingStatus() {
    return this.isLoading;
  }

  get httpReturn() {
    return this.httpReturnedObj;
  }
}
